import BaseStore from '@src/utils/store/base-store';
import DropDownMenuStore from './dropDownMenu/store';
import { observable, computed } from 'mobx';
import { jumpPage, aLink } from '@src/utils/common-util';
import { autobind } from 'core-decorators';
import SelectStore from '@src/business-components/common-language-select/store';
import copy from '@src/components/copy';
import { getLocales } from '@src/global-locales/get-page-locales-data';
import FollowUsStore from '@src/business-components/common-follow-us/store';
import { $$tracker } from '@src/tracker';
import message from '@src/components/common-message';
import useModal from '@src/utils/hooks/use-modal';
import AppointmentModal from '@src/business-components/appointment-modal';
import AppointmentModalStore from '@src/business-components/appointment-modal/store';
import AppointmentSuccessModal from '@src/business-components/appointment-success-modal';
import AppointmentSuccessModalStore from '@src/business-components/appointment-success-modal/store';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const lang = getLanguageByPath();

export const NAVTYPE = {
  ANCHOR: 'anchor',
  Link: 'link',
  SELECT: 'select'
};

const linkMap = {
  '': 'index'
};

// 玛什玛克链接
const msmkLinkMap = {
  en: 'https://mechabreak.seasungames.com/zt/msmk/en/index.html#/',
  ja: 'https://mechabreak.seasungames.com/zt/msmk/ja/index.html#/',
  ko: 'https://mechabreak.seasungames.com/zt/msmk/ko/index.html#/',
  'zh-Hant': 'https://mechabreak.seasungames.com/zt/msmk/zh-Hant/index.html#/',
  es: 'https://mechabreak.seasungames.com/zt/msmk/es/index.html#/',
  pt: 'https://mechabreak.seasungames.com/zt/msmk/pt/index.html#/',
  de: 'https://mechabreak.seasungames.com/zt/msmk/de/index.html#/',
  fr: 'https://mechabreak.seasungames.com/zt/msmk/fr/index.html#/',
  ru: 'https://mechabreak.seasungames.com/zt/msmk/ru/index.html#/',
  th: 'https://mechabreak.seasungames.com/zt/msmk/th/index.html#/'
};

// 客服中心链接
const callCenterLinkMap = {
  en: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/en-US/index',
  ja: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/ja-JP/index',
  ko: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/ko-KR/index',
  'zh-Hant': 'https://gm-mobile.amazingseasun.com/app/h5/jxj/zh-TW/index',
  es: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/es-ES/index',
  pt: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/pt-PT/index',
  de: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/de-DE/index',
  fr: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/fr-FR/index',
  ru: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/ru-RU/index',
  th: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/th-TH/index'
};

// 先驱小队活动链接
const pioneerTeamActivityLinkMap = {
  en: 'https://mechabreak.seasungames.com/p/m/pre-team/en/index.html',
  ja: 'https://mechabreak.seasungames.com/p/m/pre-team/ja/index.html',
  ko: 'https://mechabreak.seasungames.com/p/m/pre-team/ko/index.html',
  'zh-Hant': 'https://mechabreak.seasungames.com/p/m/pre-team/zh-Hant/index.html'
};

// 创作者活动链接
const creatorProgamLinkMap = {
  en: 'https://mechabreak.seasungames.com/creator_program/en/index.html#/',
  ja: 'https://mechabreak.seasungames.com/creator_program/ja/index.html#/',
  ko: 'https://mechabreak.seasungames.com/creator_program/ko/index.html#/',
  'zh-Hant': 'https://mechabreak.seasungames.com/creator_program/zh-Hant/index.html#/',
  es: 'https://mechabreak.seasungames.com/creator_program/es/index.html#/',
  pt: 'https://mechabreak.seasungames.com/creator_program/pt/index.html#/',
  de: 'https://mechabreak.seasungames.com/creator_program/de/index.html#/',
  fr: 'https://mechabreak.seasungames.com/creator_program/fr/index.html#/',
  ru: 'https://mechabreak.seasungames.com/creator_program/ru/index.html#/',
  th: 'https://mechabreak.seasungames.com/creator_program/th/index.html#/'
};

// 典藏礼包链接
const collectorsPackLinkMap = {
  en: 'https://mechabreak.seasungames.com/p/zt/2025/03/21/market/en/index.html#/',
  ja: 'https://mechabreak.seasungames.com/p/zt/2025/03/21/market/ja/index.html#/',
  ko: 'https://mechabreak.seasungames.com/p/zt/2025/03/21/market/ko/index.html#/',
  'zh-Hant': 'https://mechabreak.seasungames.com/p/zt/2025/03/21/market/zh-Hant/index.html#/',
  es: 'https://mechabreak.seasungames.com/p/zt/2025/03/21/market/es/index.html#/',
  pt: 'https://mechabreak.seasungames.com/p/zt/2025/03/21/market/pt/index.html#/',
  de: 'https://mechabreak.seasungames.com/p/zt/2025/03/21/market/de/index.html#/',
  fr: 'https://mechabreak.seasungames.com/p/zt/2025/03/21/market/fr/index.html#/',
  ru: 'https://mechabreak.seasungames.com/p/zt/2025/03/21/market/ru/index.html#/',
  th: 'https://mechabreak.seasungames.com/p/zt/2025/03/21/market/th/index.html#/'
};

/* twitch-drop 
PC：
英语：https://mechabreak.seasungames.com/p/zt/2024/07/25/twitch-drop/en/index.html#/
日语：https://mechabreak.seasungames.com/p/zt/2024/07/25/twitch-drop/ja/index.html#/
韩语：https://mechabreak.seasungames.com/p/zt/2024/07/25/twitch-drop/ko/index.html#/
繁中：https://mechabreak.seasungames.com/p/zt/2024/07/25/twitch-drop/zh-Hant/index.html#/
西语：https://mechabreak.seasungames.com/p/zt/2024/07/25/twitch-drop/es/index.html#/
葡语：https://mechabreak.seasungames.com/p/zt/2024/07/25/twitch-drop/pt/index.html#/
德语：https://mechabreak.seasungames.com/p/zt/2024/07/25/twitch-drop/de/index.html#/
法语：https://mechabreak.seasungames.com/p/zt/2024/07/25/twitch-drop/fr/index.html#/
俄语：https://mechabreak.seasungames.com/p/zt/2024/07/25/twitch-drop/ru/index.html#/
泰语：https://mechabreak.seasungames.com/p/zt/2024/07/25/twitch-drop/th/index.html#/
*/

class NaviBarStore extends BaseStore {
  selectStore = new SelectStore();
  /**
   * 关注我的store
   * @type {FollowUsStore}
   */
  followUsStore = new FollowUsStore();

  @computed
  get bgm() {
    return this.$globalStore.bgm;
  }

  /**
   * 登录展开
   * @type {boolean}
   */
  @observable loginExpand = false;

  @observable isSticky = false;

  @observable
  navList = [
    {
      type: NAVTYPE.Link,
      anchor: '#root',
      link: '',
      title: getLocales('navbar.home'),
      tracker: () => {
        $$tracker.clickMainNaviBarHome();
      }
    },
    {
      type: NAVTYPE.Link,
      link: 'news-list',
      title: getLocales('navbar.news'),
      tracker: () => {
        $$tracker.clickMainNaviBarNews();
      }
    },
    {
      type: NAVTYPE.SELECT,
      title: getLocales('navbar.games_introduction'),
      childs: [
        {
          title: getLocales('navbar.game_play'),
          link: 'game-play',
          tracker: () => {
            $$tracker.clickMainNaviBarCombat();
          }
        },
        {
          title: getLocales('navbar.mecha'),
          link: 'mecha-list',
          tracker: () => {
            $$tracker.clickMainNaviBarStrikers();
          }
        },
        {
          title: getLocales('navbar.mechaUnitList'),
          link: 'mecha-unit-list',
          tracker: () => {
            $$tracker.clickMainNaviBarCustom();
          }
        },
        {
          title: getLocales('navbar.map'),
          link: 'map',
          tracker: () => {
            $$tracker.clickMainNaviBarMaps();
          }
        },
        {
          title: getLocales('navbar.map3v3'),
          link: 'map-wpxl',
          tracker: () => {
            $$tracker.clickMainNaviBarMaps3v3();
          }
        },
        // {
        //   title: getLocales('navbar.listOfAppearances'),
        //   isHref: true,
        //   link: '//mechabreak.seasungames.com/index/en/index.html#/'
        // },
        {
          type: NAVTYPE.SELECT,
          title: getLocales('navbar.storm_plan'),
          childs: [
            {
              title: getLocales('navbar.msmk_raiders'),
              isHref: true,
              link: msmkLinkMap[lang],
              tracker: () => {
                $$tracker.clickMainNaviBarStormMashmak();
              }
            }
          ]
        },
        {
          title: getLocales('navbar.world_view'),
          link: 'world-view',
          tracker: () => {
            $$tracker.clickMainNaviBarWorld();
          }
        },
        {
          title: getLocales('navbar.wallpaper'),
          link: 'wallpaper',
          tracker: () => {
            $$tracker.clickMainNaviBarWallpaper();
          }
        }
      ]
    },
    {
      type: NAVTYPE.SELECT,
      title: getLocales('navbar.activity_zone'),
      childs: [
        {
          title: getLocales('navbar.callCenter'),
          isHref: true,
          link: callCenterLinkMap[lang],
          tracker: () => {
            $$tracker.clickMainNaviBarSC();
          }
        },
        // 造型排行
        {
          title: getLocales('navbar.styleRanking'),
          isHref: true,
          link: `https://mechabreak.seasungames.com/p/zt/2025/07/16/styling-ranking/${lang}/index.html#/`,
          tracker: () => {
            $$tracker.clickMainNaviBarSR();
          }
        },
        {
          title: getLocales('navbar.twitch_drop'),
          link: `//mechabreak.seasungames.com/p/zt/2024/07/25/twitch-drop/${lang}/index.html#/`,
          isHref: true,
          tracker: () => {
            $$tracker.clickMainNaviBarTD();
          }
        },
        {
          title: getLocales('navbar.creator_progam'),
          link: creatorProgamLinkMap[lang],
          isHref: true,
          tracker: () => {
            $$tracker.clickMainNaviBarCR();
          }
        }
      ]
    },
    // 礼包中心
    {
      type: NAVTYPE.SELECT,
      title: getLocales('navbar.pack_center'),
      childs: [
        {
          title: getLocales('navbar.collectors_pack'),
          link: collectorsPackLinkMap[lang],
          isHref: true,
          tracker: () => {
            $$tracker.clickMainNaviBarCB();
          }
        }
      ]
    }
  ];

  /**
   * 跳转页面
   * @param link 路由链接
   * @param isHref 是否为外链
   */

  toPage = (link, isHref, toast) => {
    if (toast) {
      message.info(toast);
      return;
    }

    const htmlLink = linkMap[link] || link;
    if (isHref) {
      aLink(link);
    } else if (!IS_DEV_ENV) {
      const url = `${htmlLink}.html`;
      setTimeout(() => jumpPage(url, '#/'), 500);
    } else {
      this?.redirect('/' + link);
    }
  };

  dropDownMenuStore = new DropDownMenuStore();

  @autobind
  onCopyLink() {
    copy(window.location.href);
  }

  @autobind
  onLoginContainerIn() {
    this.loginExpand = true;
  }

  @autobind
  onLoginContainerLeave() {
    this.loginExpand = false;
  }

  // 登录
  login = () => {
    const { isDownloadStage } = this.$globalStore;
    if (isDownloadStage) {
      $$tracker.clickMainNaviBarLogin();
      super.login();
    } else {
      this.appointment.open();
    }
  };

  // 退出登录
  exitAccount = async () => {
    const { authServise } = this.$globalStore;
    await this.$ztService.logout();
    this.$globalStore.accountInfo = null;
    authServise.exitAccount();
  };

  // 预约弹窗
  appointment = null;
  appointmentModalStore = new AppointmentModalStore({
    $main: this,
    appointmentSuccessCallBack: email => {
      this.appointmentSuccessModalStore.email = email;
    }
  });

  // 预约成功弹窗
  appointmentSuccessModal = null;
  appointmentSuccessModalStore = new AppointmentSuccessModalStore({ $main: this });

  @autobind
  toDownloadPage() {
    $$tracker.clickMainNaviBarDownload();
    this.toPage('download', false);
  }

  use() {
    super.use();

    this.appointment = useModal(AppointmentModal, { store: this.appointmentModalStore });
    this.appointmentSuccessModal = useModal(AppointmentSuccessModal, { store: this.appointmentSuccessModalStore });
  }
}

export default NaviBarStore;
